import Swiper, { A11y, Keyboard, Navigation, Pagination } from 'swiper';

import '../../sass/blocks/about-carousel.scss';

( () => {
    const $aboutCarousels = document.querySelectorAll('.about-carousel');

    if ( !$aboutCarousels ) return;

    $aboutCarousels.forEach( $aboutCarousel => {
        const $slider = $aboutCarousel.querySelector('.about-carousel__slider');

        const initSlider = () => {
            if ( !$slider ) return;

            const $previous = $aboutCarousel.querySelector('.about-carousel__slider-previous');
            const $next = $aboutCarousel.querySelector('.about-carousel__slider-next');
            const $pagination = $aboutCarousel.querySelector('.about-carousel__slider-pagination');

            const slider = new Swiper($slider, {
                modules: [ A11y, Keyboard, Navigation, Pagination ],
                loop: true,
                a11y: {},
                keyboard: {
                    enabled: true,
                    onlyInViewport: false
                },
                navigation: $next && $previous ? {
                    nextEl: $next,
                    prevEl: $previous
                } : false,
                pagination: {
                    el: $pagination,
                    clickable: true
                },
            });
        };

        initSlider();
    } );
} )();
